import React, { useState, useEffect } from 'react';
import { getOrgranizationalUnits } from '../../api/axios';
import DataTable from '../Table/DataTable';
import { useTranslation } from 'react-i18next';
import { Box, Container } from '@mui/material';

const OrganizationUnits = () => {
  const { t } = useTranslation('global');

  const [organizationUnits, setOrganizationUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  

  const fetchOrganzizationUnits = async() =>{
    const response = await getOrgranizationalUnits();
    console.log(response);
    setOrganizationUnits(response);
    
    setLoading(false);
  };

  useEffect(() => {
    fetchOrganzizationUnits();
  }, []);

  const columns = [
    { Header: t("list.id"), accessor: 'id' },
    { Header: t("list.name"), accessor: 'name' },
    { Header: t("list.specialCategory"), accessor: 'special_category' },

  ];

  if (loading) {
    return <p>{t("list.loading")}</p>;
  }

  return (
    <Container sx={{ mt: 5 }} fullWidth>
      <DataTable initialData={organizationUnits} columns={columns} entityName="organization-units" h2={t("list.organizationUnits")} />
    </Container>
  );
};

export default OrganizationUnits;
